import axios, { AxiosResponse } from 'axios';
import getApiBaseUrl from '../GetServer';

export interface dataRole {
  idRole: number;
  nameRole: string;
}

export interface dataUser {
  id: number;
  user: string;
  email: string;
  status: number;
  roles: dataRole[];
}

export interface UsersResponse {
  users: dataUser[];
  roles: dataRole[];
}

export const GetUsers = async (): Promise<UsersResponse> => {
  try {
    const baseUrl = getApiBaseUrl();
    const endpoint = `${baseUrl}dash/users`;

    const token = localStorage.getItem('token');

    if (!token) {
      throw new Error('Token no disponible');
    }

    const response: AxiosResponse<{
      status: number;
      message: string;
      data: {
        users: dataUser[];
        roles: dataRole[];
      };
    }> = await axios.post(endpoint, {}, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    if (response.data.status !== 200) {
      throw new Error(response.data.message);
    }

    return response.data.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};
